var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileComment14X14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1312 6.21648C12.1312 3.86194 9.83483 1.95239 7.00163 1.95239C4.16843 1.95239 1.87207 3.85888 1.87207 6.21648C1.94442 7.2318 2.36034 8.19223 3.05135 8.93964C3.74237 9.68705 4.66728 10.1769 5.67382 10.3285V12.0441L8.13961 10.3601C9.18246 10.2401 10.1511 9.76096 10.8793 9.00494C11.6076 8.24892 12.0502 7.26309 12.1312 6.21648Z",
    fill: "#CDD3E0",
    stroke: "#CDD3E0",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileComment14X14);
export default __webpack_public_path__ + "static/media/mobile-comment-14x14.ed57de1d6bbeef981cee96f869924dc6.svg";
export { ForwardRef as ReactComponent };